import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import TwitterIcon from "../components/twitter-icon"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query TwitterQuery {
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)
  const author = data.site.siteMetadata.author

  return (
    <div className="divide-zinc-300 border-solid border-y py-10 my-24">
      <div className="text-center w-11/12 sm:w-12/12 lg:w-4/6 m-auto">
        <p className="text-left my-4">著者</p>
        <p className="text-left my-4">{author.name}</p>
        <p className="text-left">{author.summary}</p>
        <TwitterIcon />
      </div>
    </div>
  )
}

export default Bio
